var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert.message)?_c('div',{staticClass:"alerts"},[_c('b-container',[_c('b-alert',{attrs:{"dismissible":"","variant":_vm.alert.kind,"show":_vm.alert.time},on:{"dismissed":function($event){return _vm.resetAlert()}}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }